import { render, staticRenderFns } from "./NurseryCard.vue?vue&type=template&id=88c218cc&scoped=true"
import script from "./NurseryCard.vue?vue&type=script&lang=js"
export * from "./NurseryCard.vue?vue&type=script&lang=js"
import style0 from "./NurseryCard.vue?vue&type=style&index=0&id=88c218cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c218cc",
  null
  
)

export default component.exports